"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ImgIconSplashSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 189, height: 174, viewBox: "0 0 189 174" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("filter", { id: `imgiconsplash-${id0}` },
                react_1.default.createElement("feColorMatrix", { in: "SourceGraphic", values: "0 0 0 0 0.349020 0 0 0 0 0.494118 0 0 0 0 1.000000 0 0 0 1.000000 0" }))),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", opacity: 0.2 },
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", { filter: `url(#imgiconsplash-${id0})`, transform: "translate(-395 -241) translate(20 84)" },
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("g", { fill: "#597EFF", fillRule: "nonzero" },
                            react_1.default.createElement("path", { d: "M189 0v174H10.427c-4.142 0-7.5-3.349-7.5-7.48 0-1.393.39-2.755 1.121-3.934l.335-.493 44.321-60.16c2.452-3.329 7.147-4.045 10.485-1.6l.357.28.339.299 19.301 18.094 37.905-47.181c2.478-3.084 6.904-3.693 10.113-1.48l.43.319.443.383.412.417 35.988 39.39-6.653 6.045-34.808-38.095-37.82 47.076-.27.317-.118.13c-2.714 2.878-7.175 3.137-10.199.679l-.403-.353-19.254-18.046-41.562 56.42h166.608V8.975h-171L9 87.04H0V0h189zM51 33c13.255 0 24 10.745 24 24S64.255 81 51 81 27 70.255 27 57s10.745-24 24-24zm0 9c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15z", transform: "translate(0 39) translate(375 118)" })))))));
}
function ImgIconSplash(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ImgIconSplashSvg, Object.assign({}, svgProps)));
}
exports.default = ImgIconSplash;
//# sourceMappingURL=ImgIconSplash.js.map